export default "__VITE_ASSET__c029077b__"